// PreCog: the console and the project module (V4Precog), and the 4Rs of a
// listening (quatre-r.helper).
export default {
  sousTitre: {
    console: 'A question put to the field and followed day after day. The scouts answer from the live field of their territory and from what they have just been reading: read the movement first, not the level.',
    sansDossier: 'A project’s PreCog: choose one in the left-hand bar.',
    dossier: '{dossier} · questions put to the field in its territories, and studies its verticals’ agenda launches on its own: read the movement first, not the level.',
    dossierAnonyme: 'The project',
    dossierNomme: 'Project {nom}',
  },
  erreur: {
    chargement: 'Could not load',
    question: 'Could not read the question',
    creation: 'Could not create',
    changement: 'Could not change',
    archivage: 'Could not archive',
    lancement: 'Could not run',
    redaction: 'Could not draft',
    enregistrement: 'Could not save',
    envoi: 'Could not upload',
    stimulus: 'Stimulus rejected',
    ancrage: 'Could not record the measurement',
  },
  territoireSansNom: 'Unnamed territory',
  agenda: {
    badge: 'agenda',
    titre: 'Study launched by the agenda on its own: it measures the expected outcome of an upcoming event. It does not belong to the project; it covers one of its verticals.',
    titreDe: 'Study launched by the {verticale} agenda on its own: it measures the expected outcome of an upcoming event. It does not belong to the project; it covers one of its verticals.',
  },
  briefing: {
    discovery: 'Idea spotted by Discovery',
    station: 'Topic spotted by the station',
    avecEcheance: '{origine}: “{sujet}”, due on {echeance}.',
    sansEcheance: '{origine}: “{sujet}”.',
  },
  confirmation: {
    armer: "Arm “{question}”?\n\n{sorties} outings over {jours} day, about {'$'}{total}. | Arm “{question}”?\n\n{sorties} outings over {jours} days, about {'$'}{total}.",
    armerEstime: "Arm “{question}”?\n\n{sorties} outings over {jours} day, about {'$'}{total} (estimate). | Arm “{question}”?\n\n{sorties} outings over {jours} days, about {'$'}{total} (estimate).",
    lancer: "Run a day for “{question}”?\n\n{sorties} outings, about {'$'}{total}.",
  },
  statut: {
    draft: 'draft',
    active: 'running',
    done: 'finished',
    stopped: 'stopped',
  },
  fermer: 'close',
  chargement: 'loading…',
  nouvelleQuestion: 'New question',
  indiceCreer: 'Create a question: it stays a draft until it is armed',
  sansDossier: 'PreCog works project by project: choose one in the left-hand bar. Its questions go to the territories it follows, and its verticals’ agenda adds the studies it launches on its own.',
  formulaire: {
    exempleQuestion: 'Who will win the 2027 presidential election?',
    exempleBriefing: 'Context given to the scouts: what they need to know so that everyone understands the question the same way, every day.',
    modePanel: 'Answer options',
    modeLibre: 'Open insights',
    aidePanel: 'you enter the possible answers: they no longer change',
    aideLibre: 'day 1 sets the indicators, then they are FROZEN: the following days can only update them',
    ajouterReponse: '+ add an answer',
    auMoinsDeux: 'At least two answers: otherwise there is nothing to choose between.',
    territoiresInterroges: 'Territories surveyed · {n}',
    ceuxDuDossier: '· the project’s own, ticked in advance',
    dossierSansTerritoire: 'This project does not follow any territory yet: open one from its page, or attach one to one of its brands.',
    eclaireursParTerritoire: 'scouts / territory',
    uneSeuleJournee: 'a single day',
    jusquAu: 'until',
    sorties: 'outing | outings',
    rythme: '({parJour}/day × {jours} day) | ({parJour}/day × {jours} days)',
    estimation: 'estimate: no day measured yet',
    creation: 'creating…',
    creerBrouillon: 'Create as draft',
    rienNePart: 'Nothing goes out until the question is armed.',
  },
  liste: {
    duDossierOuvert: 'Questions in the {nom} project, and the studies its verticals’ agenda launched on its own (marked “agenda”).',
    duDossier: 'Questions in the {nom} project.',
    ouvert: 'open',
    orion: 'Orion’s questions: the bench and R&D. Open a project to see its own.',
    retourQuestions: 'Back to questions',
    archives: 'Archive ({n})',
    noteArchives: 'Archived questions keep their series, answers and links (the bench re-scores them, the agenda does not relaunch them). They no longer run; restore one to arm it.',
    aucuneArchivee: 'No archived questions.',
    aucuneDossierOuvert: 'No questions in the {nom} project, and its verticals’ agenda has not launched any study yet. PreCog queries the live field of the territories (what the scouts see there right now), not a frozen database.',
    aucuneDossier: 'No questions in the {nom} project. PreCog queries the live field of the territories (what the scouts see there right now), not a frozen database.',
    aucune: 'No questions. PreCog queries the live field of the territories (what the scouts see there right now), not a frozen database.',
    portee: '{n} territory · {s}/terr. | {n} territories · {s}/terr.',
    uneJournee: 'one day',
    jusquAuDate: 'until {date}',
    projete: "projected {'$'}{total}",
    ressortir: 'restore',
    indiceRessortir: 'Restore from the archive: it returns to the list without restarting',
    armer: 'arm',
    indiceArmer: 'Arm: the fleet goes out and spending starts',
    arreter: 'stop',
    indiceArreter: 'Stop: no further day will go out',
    indiceLancer: 'Run a day now: it is billed',
    indiceArchiver: 'Archive: it keeps its series and leaves the list',
  },
  protocole: {
    titre: 'Protocol',
    gele: 'frozen',
    indiceRediger: 'One model call, no fleet: a few cents. You will see the indicators BEFORE paying for the first day.',
    redaction: 'drafting…',
    refaireRediger: 'redraft',
    faireRediger: 'have it drafted',
    aucunLibre: 'No protocol. It fixes the question as it is put to the individual, the definitions that must not drift, and the indicators the series will track.',
    aucunPanel: 'No protocol. It fixes the question as it is put to the individual, the definitions that must not drift, and the abstention option.',
    exige: 'It is required to arm.',
    questionPosee: 'Question put to the individual',
    aideQuestion: '“Who will win?” asks for an expectation, “who would you vote for?” for an intention: they are not the same measure.',
    definitions: 'Fixed definitions',
    terme: 'term',
    sens: 'what it means, and nothing else',
    definirTerme: '+ define a term',
    moteurs: "Engines · {theme} · ≈ {'$'}{cout} per fleet of 300",
    avecTheme: 'theme: {theme}',
    sansTheme: 'no theme',
    moteurHistorique: 'Anthropic (original engine, with web search)',
    anterieurAuBanc: 'Protocol predates the bench of 22 September 2026: redraft it to get the pair for its theme.',
    abstention: 'Abstention option offered',
    exempleAbstention: 'No opinion (empty = no abstention offered)',
    aideAbstention: 'Without it, every scout MUST choose, which makes the distribution more concentrated than it really is.',
    indicateursSuivis: 'Tracked indicators · {n}',
    aideIndicateurs: 'Frozen at launch: the following days can only update them, never add to them.',
    complet: 'Protocol complete: the question can be armed.',
    indiceValider: 'Approve this protocol: it will be frozen when the question is armed',
    enregistrement: 'saving…',
    valider: 'Approve the protocol',
  },
  theme: {
    securite: 'security',
    identite: 'identity and secularism',
    economie: 'economy and purchasing power',
    societe: 'society and institutions',
    croyance: 'beliefs about the state of the world',
    autre: 'other',
  },
  stimulus: {
    titre: 'What we show',
    indiceAttacher: 'Attach a poster, a trailer or a slogan: the fleet looks at it before answering',
    attacher: 'attach',
    rienDeMontre: 'Nothing shown: the scouts answer on the wording alone, as on the phone. A poster, a trailer or a slogan changes the question asked, and that is often the one you want to measure.',
    genre: {
      image: 'image',
      video: 'video',
      texte: 'text',
    },
    indiceDeposer: 'Upload the image or video the twins will see',
    envoi: 'uploading…',
    choisirFichier: 'choose a file',
    ouAdresse: 'or paste a URL: a trailer that is not out yet does not have one.',
    adresseVideo: 'https://… (YouTube or video file)',
    adresseImage: 'https://… (the poster, the visual)',
    exempleTexte: 'The text shown as it is: a slogan, a promise, a title.',
    exempleTitre: 'What it is, for you: the panellist never reads it',
    moteurDecrit: 'The engine DESCRIBES what is shown (what you see, what you hear, what is written) without saying whether it works. Judgement belongs to the scouts: a model that judges in their place gives its opinion to a hundred panellists at once.',
    enregistrement: 'saving…',
    enregistrer: 'Save',
    retirer: 'remove',
    texteManque: 'The text to show is missing.',
    adresseManque: 'The URL is missing, or is not http(s).',
  },
  serie: {
    aucuneBrouillon: 'No day yet. The question is a draft: arm it or run a day by hand.',
    aucuneAttente: 'No day yet. The first fleet has not come back.',
    bouge: 'What is moving · {jour}',
    niveauIndicatif: 'indicative level: twins reproduce levels poorly and changes well',
    dispersion: 'Spread',
    dispersionVide: 'no usable answer that day: nothing to spread',
    dispersionNulle: 'near zero: on a divisive question this is an artificial CONSENSUS among twins, not unanimity',
    dispersionReelle: 'the scouts are not all saying the same thing',
    deplaces: 'Moved by research',
    deplacesAucun: 'none: the outing added nothing, the series only measures what the model already knew',
    deplacesPart: 'share of scouts whose answer changed after research',
    eclaireurs: 'Scouts',
    journees: '{n} day in the series | {n} days in the series',
    indicateursGeles: 'Indicators frozen on day 1',
    ecartInterquartile: 'interquartile range: the real spread',
    mediane: 'Median, not mean: a lone outlier is neutralised, but tracked as soon as several scouts confirm it.',
  },
  ancrage: {
    titre: 'Gap to real measurements',
    indice: 'Record a published poll or a real count: it corrects nothing, it shows the gap',
    ajouter: '+ add a measurement',
    exempleSource: 'source (Ifop 12/10, prefecture…)',
    enregistrer: 'save',
    aucun: 'No real measurement recorded. Without one, there is no knowing how far off the instrument is.',
  },
  bord: {
    titre: 'By political leaning',
    personne: 'nobody on this side answered',
    reponses: '{n} answer | {n} answers',
    part: '{famille}, {option}: {pct}% ({n} of {total})',
    horsFamilles: '{n} outside the four families (“other” bloc)',
    sansBord: '{n} with no political side: the territory has no electoral anchor',
    seuil: 'For every family to carry a percentage, the smallest one needs enough scouts: it drives the spend, not the average.',
  },
  famille: {
    gauche: 'left',
    majorite: 'presidential majority',
    droite: 'right',
    rn: 'RN + Reconquête',
  },
  derive: {
    titre: 'Political drift: intention at time T',
    ampleur: 'magnitude {ampleur} pts · n={n}',
    ancrage: 'Anchor: {scrutin}',
    nonMesurable: 'With {n} scout in this bloc, the drift cannot be measured. | With {n} scouts in this bloc, the drift cannot be measured.',
  },
  bloc: {
    gaucheRadicale: 'radical left',
    gauche: 'left',
    centre: 'centre',
    droite: 'right',
    droiteRadicale: 'radical right',
    autre: 'other',
  },
  demo: {
    titre: 'Who answered: age, gender, occupation, segments',
    lecture: 'reading the corpus…',
    toutLaSerie: 'Across the whole series',
    stabilite: 'Sample stability',
    stabiliteAide: '· median age and size, day by day',
    reponses: '{n} answer | {n} answers',
    age: '{age} yrs',
  },
  corpus: {
    titre: 'Corpus: what each scout answered',
    avant: 'before: {option}',
    affichees: '{n} of {total} shown.',
  },
  // The 4Rs of a listening: their names stay the originals, their meaning is translated.
  quatreR: {
    reach: 'How many different people talk about it, and on how many platforms.',
    resonance: 'The tone of what is said: the more positive, the higher the score.',
    retention: 'Those who come back to talk about it, message after message: loyalty.',
    relevance: 'The trajectory: is the score rising or falling from one period to the next?',
  },
}
